import { TotpManager } from "./_components/totp-manager";

export const dynamic = "force-dynamic";

export default function SecurityPage() {
  return (
    <div className="px-6 py-6 lg:px-10 max-w-3xl">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">Sécurité du compte</h1>
        <p className="text-sm text-muted-foreground">
          Gestion de l&apos;authentification à deux facteurs pour ce compte
          super-administrateur.
        </p>
      </header>
      <TotpManager />
    </div>
  );
}
